import * as gPhoneUtil from "google-libphonenumber"
import * as R from "ramda"
import {BinaryChoice} from './Model/FormItems'
import Forge from 'node-forge'

export type Nullable<T> = T | undefined | null

const phoneUtil = gPhoneUtil.PhoneNumberUtil.getInstance()
const PNF = gPhoneUtil.PhoneNumberFormat

export const phoneNumberFormatter = (phoneNumber: string) => {
	return phoneUtil.format(phoneUtil.parseAndKeepRawInput(phoneNumber, 'US'), PNF.NATIONAL)
}

export const capitalize = (text: string = '') => {
	return text ? text.toLowerCase()
		.split(' ')
		.map((s) => s.charAt(0).toUpperCase() + s.substring(1))
		.join(' ') : ''
}

export const mapUndefinedToBinaryChoice = (boolItem?: boolean) => {
	return boolItem !== undefined ? (boolItem ? BinaryChoice.YES : BinaryChoice.NO) : BinaryChoice[BinaryChoice.NA]
}

export const generateYearsArray = (range: number, top?: number) => {
	const upperLevel = top || new Date().getFullYear() + 2

	return R.range(upperLevel - range, upperLevel + 1)
}

export const yesNoNormalizer = (val?: any) => (val ? 'Yes' : 'No')

export const mapToYesOrNoWithNullable = (item?: boolean | null) => {
	if (item === undefined || item === null) return ''

	return item ? 'Yes' : 'No'
}


export const mapYesNoUnknownToBool = (item?: string) => {
	if(item === ""){
		return null;
	}else if(item === "Yes"){
		return true;
	}else if(item === "No"){
		return false;
	}
	return null;
}

export const convertFileToBase64 = async (file: File): Promise<string> => {
	return new Promise((resolve) => {
		const fileReader = new FileReader()
		fileReader.readAsDataURL(file)
		fileReader.onload = () => {
			resolve(
				typeof fileReader.result! === 'string' ? fileReader.result : String.fromCharCode.apply(null, fileReader.result as any),
			)
		}
	})
}

export const encryptPayload = (payload: any, pk: string) => {
	const rsaPublicKey =
		// tslint:disable-next-line:max-line-length
		'-----BEGIN PUBLIC KEY-----\n' +
		pk +
		'\n-----END PUBLIC KEY-----';

	const { util, cipher, pki, random } = Forge

	// Create AES 256 key (32 b)
	const key = random.getBytesSync(32)

	// Generate IV based on the first 16b of the key
	const iv = util.hexToBytes(util.bytesToHex(key).slice(0,32));


	// Create AES w/ CBC padding cipher via Forge lib
	const c = cipher.createCipher('AES-CBC', key)

	// console.log(JSON.stringify(payload));
	// Use cipher to encrypt our stringified payload
	c.start({ iv })
	c.update(util.createBuffer(JSON.stringify(payload)))
	c.finish()

	// Encode payload as b64 for transport
	const encryptedPayloadString = util.encode64(c.output.data)

	// Encrypt the AES key previously generated with master public key
	const publicKey: any = pki.publicKeyFromPem(rsaPublicKey)
	const encryptedKey = util.encode64(publicKey.encrypt(key))

	return {
		key: encryptedKey,
		payload: encryptedPayloadString,
	}
}



// @ts-ignore
const safariCheck = !window.safari || (typeof window.safari !== 'undefined' && window.safari.pushNotification)
const safariObjCheck = ((p) => p.toString() === '[object SafariRemoteNotification]')(safariCheck)
// @ts-ignore
export const isSafari = /constructor/i.test(window.HTMLElement) || safariObjCheck

// @ts-ignore
export const isIE = /*@cc_on!@*/ false || !!document.documentMode
